import config from "../config";
import PlatformError from "../PlatformError";

export default new PlatformError("ERROR", config.defaultMessage, "StartTrackingError", "$step_name$", config.defaultMessageId)